import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from 'wonderbly-components/lib/Button';
import ResponsiveImage from '../../ResponsiveImage';

import './FeaturedItem.scss';

const FeaturedItem = props => (
  <a
    href={props.href}
    className={cx('featured-item', {
      'featured-item-reversed': props.reversed,
      [`color-${props.color}`]: props.color,
    })}
    style={{ backgroundColor: props.backgroundColor }}>
    <div
      className="featured-item-image">
      <ResponsiveImage
        images={props.image}
        alt={props.image.alt || ''}
        className="featured-item-image-asset"
      />
    </div>
    <div className="container-guttered">
      <div className="featured-item-copy">
        <h3 className="featured-item-title">{props.title}</h3>
        <div className="featured-item-description">
          <p>{props.description}</p>
        </div>
        <Button
          colour={props.color || 'grey-dark'}
          outlined
          className="featured-item-button">
          {props.cta}
        </Button>
      </div>
    </div>
  </a>
);

FeaturedItem.propTypes = {
  reversed: PropTypes.bool,
  color: PropTypes.string,
  href: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};

export default FeaturedItem;



// WEBPACK FOOTER //
// ./src/client/js/view/components/FeaturedItems/FeaturedItem/FeaturedItem.js